import { register } from "async-ops";
import { callMdaeApi } from "../../../../call-web-api";

export const GET_AUDIT_GROUPS_FOR_FINDING_GROUP =
  "GET_AUDIT_GROUPS_FOR_FINDING_GROUP";

export const service = async (data) => {
  const response = await callMdaeApi({
    url: `/api/v1/finding-groups/audit-groups?findingGroupId=${data?.findingGroupId ||
      0}`,
    type: "GET",
  });
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_GROUPS_FOR_FINDING_GROUP, service, mock);
